import React from 'react';

/**
 * PageFrame — adaptive content shell (ADS layout engine).
 * @param {'default'|'wide'|'reading'} [measure] — content max-width strategy
 */
const PageFrame = ({ children, className = '', dir, wide = false, measure = 'default' }) => {
  const measureKey = wide ? 'wide' : measure;
  const innerMeasure =
    measureKey === 'wide'
      ? ' ads-page-frame__inner--wide'
      : measureKey === 'reading'
        ? ' ads-page-frame__inner--reading'
        : '';

  return (
    <div className={`ads-page-frame page-shell-compact ${className}`.trim()} dir={dir}>
      <div className={`ads-page-frame__inner${innerMeasure}`}>{children}</div>
    </div>
  );
};

export default PageFrame;
